import { useEffect, useState } from "react";
import formatMoney from "../../../../../formatMoney";

function NetSummary({ object }) {
  const [netValue, setNetValue] = useState("0.00");
  const [vatValue, setVatValue] = useState("0.00");

  useEffect(() => {
    const gross = parseFloat(object?.gross) || 0;
    const vatExempt = parseFloat(object?.vatExempt) || 0;
    const zeroRated = parseFloat(object?.zeroRated) || 0;
    const dedductedGross = gross - vatExempt - zeroRated;

    const vatRate = 0.12;

    let net = 0;
    let vat = 0;

    if (dedductedGross > 0) {
      net = dedductedGross / (1 + vatRate);
      vat = dedductedGross - net;
    }

    if (object?.isVatable) {
      const formmatedNet = formatMoney(net);
      setNetValue(formmatedNet);

      const formmatedVat = formatMoney(vat);
      setVatValue(formmatedVat);
    } else {
      setNetValue(formatMoney(object?.gross || 0));
      setVatValue(formatMoney(0));
    }

    // setFormData({ ...object, net: formmatedNet, vat: formmatedVat });
  }, [object]);

  return (
    <>
      <div className="d-flex flex-column card p-3 overflow-hidden">
        <div className="d-flex justify-content-between">
          <p className="m-0 text-muted">Vatable Sales:</p>
          <div
            className="d-flex gap-2 fw-bold text-truncate"
            style={{ maxWidth: "200px" }}
          >
            &#8369;
            <p className="m-0 text-truncate">{netValue}</p>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <p className="m-0 text-muted">VAT Amount:</p>
          <div
            className="d-flex gap-2 fw-bold text-truncate"
            style={{ maxWidth: "200px" }}
          >
            &#8369;
            <p className="m-0 text-truncate">{vatValue}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default NetSummary;
